export class CatalogCategory
{
  id: number;
  name: string;
  visible: boolean;
  isProduct: boolean;
}
